import state from './state'
import mutations from './mutations'

const settings = {
  state,
  mutations
}

export default settings



// WEBPACK FOOTER //
// ./src/store/navigation/index.js